var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{staticClass:"detailView"},[_c('Material',{attrs:{"dataType":_vm.dataType,"type":_vm.type,"productId":_vm.productId,"materialTypeId":_vm.materialTypeId,"productType":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }